import PropTypes from "prop-types"
import { VpnKey } from "@mui/icons-material"
import { connect } from "react-redux"
import { get } from "lodash"
import Header from "modules/home-header"

function TeamTokensHeader({ account, name }) {
  const teamName = name ? `Team Tokens: ${name}` : "Team Tokens"
  return <Header Icon={VpnKey} title={teamName} account={account} />
}

TeamTokensHeader.propTypes = {
  account: PropTypes.string.isRequired,
  name: PropTypes.string,
}

export default connect(state => ({ name: get(state, "global.data.teamTokens.data.team.name") }), null)(TeamTokensHeader)
